module.exports = __webpack_public_path__ + "static/media/supportLogo1.216ab56b.svg";